<template>
  <div>
    <v-data-table
      :headers="headers"
      :items="agents"
      :items-per-page="-1"
      sortable
      v-if="loaded"
      class="elevation-1"
    >
      <template v-slot:top>
        <v-toolbar dark color="primary">
          <v-toolbar-title>Agents</v-toolbar-title>
          <v-spacer></v-spacer>
          <AddAgent @refresh="initialize()" v-if="user.permissions.admin" />
        </v-toolbar>
      </template>
      <template v-slot:[`item.actions`]="{ item }">
        <!-- <v-icon small class="mr-2" :to="`/agents/${item.id}`">
        mdi-pencil
      </v-icon>
      <v-icon small class="mr-2"> mdi-eye </v-icon> -->
        <v-icon
          small
          class="mr-2"
          @click="deleteAgent(item)"
          v-if="user.permission_admin"
        >
          mdi-delete
        </v-icon>
      </template>
      <template v-slot:[`item.flag`]="{ item }">
        <div class="flag">
          <img
            :src="`https://catamphetamine.gitlab.io/country-flag-icons/3x2/${item.country_code}.svg`"
            class="flag"
          />
        </div>
      </template>
      <template v-slot:[`item.slack_id`]="{ item }">
        <div class="item-flex" v-if="slackMap[item.slack_id]">
          <div class="flag">
            <img
              class="flag round"
              :src="`${slackMap[item.slack_id].image}`"
              alt=""
            />
          </div>
          {{ slackMap[item.slack_id].name || "" }}
        </div>
        <div v-else>
          {{ item.slack_id }}
        </div>
      </template>
      <template v-slot:[`item.notifications_enabled`]="{ item }">
        <v-icon small :color="item.notifications_enabled ? 'green' : 'red'">
          mdi-checkbox-marked-circle-outline
        </v-icon>
      </template>
      <template v-slot:[`item.team`]="{ item }">
        {{ teamMap[item.team].team }}
      </template>
    </v-data-table>
    <v-snackbar v-model="snackbar" :color="snackbarColor">
      <v-icon class="mr-2">{{ snackbarIcon }}</v-icon> {{ snackbarText }}
    </v-snackbar>
  </div>
</template>

<script>
import axios from "@/plugins/axios";
import addAgent from "@/components/AddAgent.vue";
export default {
  name: "DedicatedCustomers",
  components: {
    AddAgent: addAgent,
  },
  data: () => ({
    dialog: false,
    dialogDelete: false,
    slackMap: {},
    user: undefined,
    loaded: false,
    teamMap: {},
    headers: [
      { text: "Country", value: "flag", sortable: false },
      { text: "Name", value: "first_name", align: "end", sortable: false },
      {
        text: "",
        value: "last_name",
        align: "start",
        sortable: false,
      },
      { text: "Email", value: "email", sortable: false },
      { text: "Slack", value: "slack_id", sortable: false },
      { text: "Zendesk ID", value: "zendesk_id", sortable: false },
      { text: "Skip Count", value: "skip_count", sortable: false },
      {
        text: "Notifications",
        value: "notifications_enabled",
        sortable: false,
      },
      { text: "Team", value: "team", sortable: false },
      { text: "Actions", value: "actions", sortable: false },
    ],
    agents: [],
    snackbar: false,
    snackbarColor: "",
    snackbarIcon: "",
    snackbarText: "",
  }),

  computed: {
    formTitle() {
      return this.editedIndex === -1 ? "New Agent" : "Edit Agent";
    },
  },

  created() {
    this.initialize();
  },

  methods: {
    initialize() {
      let that = this;
      axios.get("/api/v1/user/me").then((res) => {
        that.user = res.data;
      });
      axios.get("/api/v1/agents/list").then((res) => {
        that.agents = res.data.ungrouped;
        that.slackMap = res.data.slackMap;
      });
      axios.get("/api/v1/teams/list").then((res) => {
        let teams = res.data;
        teams.forEach((team) => {
          that.teamMap[team.id] = team;
        });
        that.loaded = true;
        this.snackbar = true;
        this.snackbarColor = "success";
        this.snackbarIcon = "mdi-check";
        this.snackbarText = "Loaded";
      });
    },
    deleteAgent(agent) {
      let that = this;
      axios
        .post("/api/v1/agents/remove", { agent: agent.email })
        .then(() => {
          that.initialize();
        })
        .catch((err) => {
          console.log(err);
          that.snackbar = true;
          that.snackbarColor = "error";
          that.snackbarIcon = "mdi-alert";
          that.snackbarText = err.response.data;
        });
    },
  },
};
</script>

<style scoped lang="scss">
.flag {
  display: flex;
  align-items: center;
  justify-content: center;
  img {
    width: 20px;
    height: 20px;
    pointer-events: none;
  }
}
.item-flex {
  display: flex;
  gap: 10px;
  align-items: center;
}

.round {
  border-radius: 50%;
}
</style>
